import { z } from "zod";

const entitySchema = z.object({
	name: z.string().min(1, "Name is required"),
	address: z.string().min(1, "Address is required"),
	established_date: z.string().refine((date) => !isNaN(Date.parse(date)), {
		message: "Invalid date format",
	}),
	company: z.string().uuid("Company is required"),
});

export const entityCreateSchema = entitySchema;
export const entityUpdateSchema = entitySchema.partial();
